"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var Gallery_1 = __importDefault(require("../Gallery"));

var Image_1 = __importDefault(require("../Gallery/Image"));

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * Moment to display entities that are named after the `Story`'s subject'.
 */


var NamedAfterMoment = function NamedAfterMoment(props) {
  var color = props.color,
      data = props.data;
  var classes = (0, useStyles_1.default)();
  /* eslint-disable react/jsx-props-no-spreading */

  return react_1.default.createElement(Gallery_1.default, __assign({}, props, {
    bodyClassName: classes.momentBody
  }), data.map(function (_a) {
    var description = _a.description,
        image = _a.image,
        fallback = _a.fallback,
        label = _a.label,
        website = _a.website;
    return react_1.default.createElement(Image_1.default, {
      className: classes.galleryImage,
      color: color,
      content: react_1.default.createElement("div", {
        className: "named-after-item-content"
      }, description && react_1.default.createElement("div", {
        className: "named-after-item-content__description"
      }, description), website && react_1.default.createElement(Button_1.default, {
        className: classes.button,
        href: website,
        style: {
          background: color.background,
          color: color.text
        },
        target: "_blank",
        variant: "contained"
      }, "Learn More")),
      key: label,
      label: label,
      noImage: !image,
      src: image || fallback
    });
  }));
};

NamedAfterMoment.propTypes = {
  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Information to build the `GalleryImage`s */
  data: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,

  /** Determines the `SideBarSection` `Icon` of the `Moment`. */
  icon: prop_types_1.default.element,

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the `SideBarSection` text of the `Moment`. */
  label: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
NamedAfterMoment.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.Tile,
  type: constants_1.MomentType.NamedAfter
});
exports.default = NamedAfterMoment;